"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const form_data_1 = __importDefault(require("form-data"));
const AppError_1 = __importDefault(require("../../../common/errors/AppError"));
const resource_1 = __importDefault(require("../../../common/resource"));
class Registry extends resource_1.default {
    constructor(token, url) {
        super(token, url);
        this.url = `${this.url}/registry`;
    }
    create(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request.post(`${this.url}/register`, data, { headers: { Authorization: this.token ? `Bearer ${this.token}` : '' } })
                .then((res) => res.data)
                .catch((err) => { throw new AppError_1.default(err.response.data, err.response.status); });
        });
    }
    list(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request.post(`${this.url}/list`, filters, { headers: { Authorization: this.token ? `Bearer ${this.token}` : '' } })
                .then((res) => res.data)
                .catch((err) => { throw new AppError_1.default(err.response.data, err.response.status); });
        });
    }
    download(dltId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request.get(`${this.url}/${dltId}/download`, { headers: { Authorization: this.token ? `Bearer ${this.token}` : '' }, responseType: 'arraybuffer' })
                .then((res) => Buffer.from(res.data, 'base64'))
                .catch((err) => { throw new AppError_1.default(err.response && err.response.data ? err.response.data : 'Could not download file', err.response && err.response.status ? err.response.status : 500); });
        });
    }
    verifyByHash(hash) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request.post(`${this.url}/verify/hash`, { hash }, { headers: { Authorization: this.token ? `Bearer ${this.token}` : '' } })
                .then((res) => res.data)
                .catch((err) => { throw new AppError_1.default(err.response.data, err.response.status); });
        });
    }
    verifyByFile(file) {
        return __awaiter(this, void 0, void 0, function* () {
            const form = new form_data_1.default();
            form.append('file', file);
            return this.request.post(`${this.url}/verify`, form, { headers: Object.assign({ Authorization: this.token ? `Bearer ${this.token}` : '' }, form.getHeaders()) })
                .then((res) => res.data)
                .catch((err) => { throw new AppError_1.default(err.response.data, err.response.status); });
        });
    }
}
exports.default = Registry;
